import React from "react";
import { useCart } from "../context/CartContext";
import "../styles/ProductCard.css";

const ProductCard = ({ product }) => {
  const { addToCart, isInCart } = useCart();

  const { name, price, offerPrice, image } = product;
  const hasOffer = offerPrice && offerPrice < price;
  const discountPercent = hasOffer
    ? Math.round(((price - offerPrice) / price) * 100)
    : 0;

  const productId = product.id;

  return (
    <div className="product-card">
      {hasOffer && <div className="offer-badge">{discountPercent}% OFF</div>}

      <div className="product-image-wrapper">
        <img src={image} alt={name} className="product-image" />
      </div>

      <h4 className="product-name">{name}</h4>

      <div className="product-price">
        {hasOffer ? (
          <>
            <span className="original-price">₹{price}</span>
            <span className="offer-price">₹{offerPrice}</span>
          </>
        ) : (
          <span className="normal-price">₹{price}</span>
        )}
      </div>

      {!isInCart(productId) ? (
        <button
          className="add-to-cart-btn"
          onClick={() => addToCart(product)}
        >
          Add to Cart
        </button>
      ) : (
        <button className="add-to-cart-btn added" disabled>
          ✅ Added
        </button>
      )}

    </div>
  );
};

export default ProductCard;
